import { render } from "./GameView.vue?vue&type=template&id=6d9c9356"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"

import "./GameView.vue?vue&type=style&index=0&id=6d9c9356&lang=css"

import exportComponent from "/Users/zellwegv/repos-work/fw-312-bird-identification-game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__